"use strict"; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ConnectionHealthPolicyConfiguration = /*#__PURE__*/_createClass(function ConnectionHealthPolicyConfiguration() {
  _classCallCheck(this, ConnectionHealthPolicyConfiguration);

  this.minHealth = 0;
  this.maxHealth = 1;
  this.initialHealth = 1;
  this.connectionUnhealthyThreshold = 25;
  this.noSignalThresholdTimeMs = 10000;
  this.connectionWaitTimeMs = 10000;
  this.zeroBarsNoSignalTimeMs = 5000;
  this.oneBarWeakSignalTimeMs = 5000;
  this.twoBarsTimeMs = 5000;
  this.threeBarsTimeMs = 10000;
  this.fourBarsTimeMs = 20000;
  this.fiveBarsTimeMs = 60000;
  this.cooldownTimeMs = 60000;
  this.pastSamplesToConsider = 15;
  this.goodSignalTimeMs = 15000;
  this.fractionalLoss = 0.5;
  this.packetsExpected = 50;
  this.maximumTimesToWarn = 2;
  this.missedPongsLowerThreshold = 1;
  this.missedPongsUpperThreshold = 4;
  this.maximumAudioDelayMs = 60000;
  this.maximumAudioDelayDataPoints = 10;
});

exports.default = ConnectionHealthPolicyConfiguration;